import API from "../../../../services/api";

export const getProfile = async () => {

    const res = await API.get("/user/profile");

    return res.data;

};

export const updateProfile = async (data) => {

    const res = await API.put("/user/profile", data);

    return res.data;

};